export enum QuestionnaireStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum QuestionnaireAnswerType {
  TEXT = 'TEXT',
  SCALE = 'SCALE',
  NUMBER = 'NUMBER',
  YES_NO = 'YES_NO',
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTISELECT = 'MULTISELECT',
}

export enum QuestionnaireSubmissionStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}
